import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"upload\"><path fill=\"none\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M17 11.667v3.555c0 .982-.796 1.778-1.778 1.778H2.778A1.778 1.778 0 0 1 1 15.222v-3.555m12.444-6.223L9 1 4.556 5.444M9 1v10.667\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol